import { useTranslation } from 'react-i18next';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

const DashboardNSRChartDisclaimer = () => {
  const { t } = useTranslation('analytics');
  return (
    <Text size='medium' css={{ color: theme.colors.neutral60 }}>
      {t('Last Month')}
    </Text>
  );
};

export default DashboardNSRChartDisclaimer;
